import React, { Fragment, ReactNode } from 'react';
import { Hit } from 'react-instantsearch-core';
import HTMLReactParserSafe from '../../partials/html-react-parser-safe';

/**
 * This interface represents the attributes on the index that are set as "searchable attributes"
 * in the Algolia web console as key/value pairs. For now this only works for attributes that are
 * strings or arrays of strings (which is usually what we want to show as results, anyway)
 */
interface SearchableAttributes {
  [key: string]: string | string[];
}

interface Props {
  hit: Hit<SearchableAttributes>,
  displayKey: string[],
}

const renderDisplayKey = (
  item: Hit<SearchableAttributes>,
  key: string,
  displaySeparator: boolean,
  separator: ReactNode,
): ReactNode => {
  // eslint-disable-next-line no-underscore-dangle
  const highlightResult = item._highlightResult[key];

  // If no highlight results are returned, just return the field value
  if (!highlightResult) {
    return item[key];
  }

  const html = Array.isArray(highlightResult)
    ? highlightResult.map((result) => result.value).join(', ')
    : highlightResult.value;

  const styledHtml = html
    .replaceAll('__aa-highlight__', '<em>')
    .replaceAll('__/aa-highlight__', '</em>');

  return (
    // Algolia warns here: https://www.algolia.com/doc/guides/building-search-ui/ui-and-ux-patterns/highlighting-snippeting/js/#sanitization-of-the-results
    // that results must be sanitized, which this component performs
    <Fragment key={key}>
      <HTMLReactParserSafe
        html={styledHtml}
      />
      {displaySeparator && separator}
    </Fragment>
  );
};

const SuggestedHit: React.FC<Props> = ({
  hit,
  displayKey,
}) => {
  return (
    <span key={hit.objectID}>
      {displayKey.map((key, i) => (
        renderDisplayKey(hit, key, i !== displayKey.length - 1, <span className="separator" />)
      ))}
    </span>
  );
};

export default SuggestedHit;
